import styled from 'styled-components';

export const Contents = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const Tab = styled.div`
  box-sizing: border-box;
  display: flex;
  // height: 74px;
  width: 100%;
  padding: 0px 15px 20px 15px;
  background-color: #ffffff;
`;

export const Button = styled.button`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 34px;
  border: solid 1px #78818e;
  background-color: #ffffff;
  font-size: 13px;
  &.active {
    background-color: #78818e;
    color: #ffffff;
  }
`;

export const SeasonTab = styled.div`
  position: absolute;
  top: -35px;
  right: 15px;
  display: flex;
  justify-content: flex-end;
  height: 26px;
  width: 100%;

  h2 {
    margin-left: 4px;
    font-weight: bold;
    color: #000000;
  }

  ul {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #fff;

    .on {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      height: 18px;
      border-bottom: 1px solid #ed2026;
    }

    li {
      div {
        position: relative;
        height: 100%;
        width: 1px;
        margin: 0px 8px;

        &:after {
          content: '';
          position: absolute;
          top: -4px;
          height: 13px;
          width: 1px;
          border-right: 1px solid #f2f2f2;
        }
      }
    }
  }
`;

export const Table = styled.ul`
  display: flex;
  flex-direction: column;
  border: 1px solid #f2f2f2;
`;

export const TableHeader = styled.li`
  display: flex;
  align-items: center;
  height: 36px;
  width: 100%;
  border-bottom: 1px solid #f2f2f2;

  & > div {
    display: flex;
    justify-content: center;
    font-size: 11px;
  }

  .player {
    justify-content: flex-start !important;
    width: 134px;
    padding-left: 15px;
  }

  .avg,
  .hit,
  .rbi,
  .ops {
    flex: 1;
  }
`;

export const TableList = styled.li`
  display: flex;
  align-items: center;
  height: 36px;
  width: 100%;
  border-bottom: 1px solid #f2f2f2;

  &:last-child {
    border-bottom: none;
  }

  & > div {
    display: flex;
    justify-content: center;
    font-size: 13px;
  }

  .player {
    justify-content: flex-start !important;
    width: 134px;
    padding-left: 15px;
  }

  .avg,
  .hit,
  .rbi,
  .ops {
    flex: 1;
    font-size: 13px;
    font-weight: 300;
  }
`;

export const Empty = styled.li`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px;
  border-bottom: none;
`;
